<div class="form-group" [formGroup]="group">
  <div  >
    @if (element.elementOptions.label) {
      <label [attr.for]="element.elementOptions.id" [ngClass]="element?.theme?.labelClass">
        {{ element.elementOptions.label }}
        @if (element.validations?.required) {
          <b style="color:red">*</b>
        }
        @if (element?.tooltip?.display) {
          <span>
            <i class="fa fa-question-circle" aria-hidden="true" placement="right" ngbTooltip="{{element.tooltip.text || 'right'}}"></i>
          </span>
          } :
        </label>
      }
    </div>
    <div class="input-group"  [ngClass]="element?.theme?.childLabel">
      <input class="form-control" ngbDatepicker #d="ngbDatepicker" formControlName="control" [minDate]="min" [maxDate]="max">

      <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
        <img src="assets/calendar-icon.svg" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
      </button>

    </div>
    @if (element.group.controls[this.element['name']].dirty && !element.group.controls[this.element['name']].pristine &&element.group.controls[this.element['name']].errors) {
      <div class="alert alert-danger" role="alert">
        <rs-error-message [fieldForm]="element.group.controls[this.element['name']]" [field]="element"></rs-error-message>
      </div>
    }
  </div>
